<div class="mtn-button container {{color}}" fxLayoutAlign="center center" matRipple [matRippleDisabled]="disabled"
     [ngClass]="{disabled: disabled}" (click)="handleClick($event)">
  <div class="icon-container">
    <fa-icon  class="primary-icon {{iconColor}}" [icon]="icon" *ngIf="icon && !imageIcon"></fa-icon>
    <fa-icon class="ellipsis" icon="ellipsis-h" *ngIf="showEllipsis && !imageIcon"></fa-icon>
    <img *ngIf="imageIcon" height="30" [src]="imageIcon" alt="point click">
  </div>
  <div class="badge-container" *ngIf="badgeCount > 0" fxLayoutAlign="center center">
    <div class="badge">{{badgeCount}}</div>
  </div>
  <div class="color-bar"></div>
  <div class="disabled-overlay" *ngIf="disabled" mtnClickTrap></div>
</div>
